<template>
  <custom-collapse>
    <el-row>
      <el-col :span="12">
        <el-form-item label="授权产品" prop="authProduct">
          <el-select
            v-model="detail.authProduct"
            class="small-form-field"
            multiple
            filterable
            @change="handleAuthProductChange"
          >
            <el-option
              v-for="(name, id) in authProductMap"
              :key="id"
              :label="id + '. ' + name"
              :value="+id"
            ></el-option>
          </el-select>
          <el-button type="text" @click="detail.remarkShow.authProductRemarksShow = true">备注</el-button>
          <el-input
            v-if="detail.remarkShow.authProductRemarksShow || detail.copyrightDetailExtend.authProductRemarks"
            v-model="detail.copyrightDetailExtend.authProductRemarks"
            class="remark"
            placeholder="备注信息"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="授权区域" prop="copyrightArea">
          <el-select
            v-model="detail.copyrightArea"
            class="small-form-field"
            multiple
            filterable
          >
            <el-option
              v-for="(name, id) in copyrightAreaMap"
              :key="id"
              :label="id + '. ' + name"
              :value="+id"
            ></el-option>
          </el-select>
          <el-button type="text" @click="detail.remarkShow.copyrightAreaRemarksShow = true">备注</el-button>
          <el-input
            v-if="detail.remarkShow.copyrightAreaRemarksShow || detail.copyrightDetailExtend.copyrightAreaRemarks"
            v-model="detail.copyrightDetailExtend.copyrightAreaRemarks"
            class="remark"
            placeholder="备注信息"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否可转售授权">
          <el-radio-group v-model="detail.canAuth">
            <el-radio v-for="(name, id) in canAuthMap" :key="id" :label="+id">{{ name }}</el-radio>
          </el-radio-group>
          <el-button type="text" @click="detail.remarkShow.canAuthRemarksShow = true">备注</el-button>
          <el-input
            v-if="detail.remarkShow.canAuthRemarksShow || detail.copyrightDetailExtend.canAuthRemarks"
            v-model="detail.copyrightDetailExtend.canAuthRemarks"
            class="remark"
            placeholder="备注信息"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否可维权" prop="canLegalRights">
          <el-radio-group v-model="detail.canLegalRights">
            <el-radio v-for="(name, id) in canLegalRightsMap" :key="id" :label="+id">{{ name }}</el-radio>
          </el-radio-group>
          <el-button type="text" @click="detail.remarkShow.canLegalRightsRemarksShow = true">备注</el-button>
          <el-input
            v-if="detail.remarkShow.canLegalRightsRemarksShow || detail.copyrightDetailExtend.canLegalRightsRemarks"
            v-model="detail.copyrightDetailExtend.canLegalRightsRemarks"
            class="remark"
            placeholder="备注信息"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="授权形式" prop="authForm">
          <el-select
            v-model="detail.authForm"
            class="small-form-field"
            multiple
            filterable
          >
            <el-option
              v-for="authForm in authFormList"
              :disabled="authForm.disabled"
              :key="authForm.id"
              :label="authForm.id + '. ' + authForm.name"
              :value="+authForm.id"
            ></el-option>
          </el-select>
          <el-button type="text" @click="detail.remarkShow.authFormRemarksShow = true">备注</el-button>
          <el-input
            v-if="detail.remarkShow.authFormRemarksShow || detail.copyrightDetailExtend.authFormRemarks"
            v-model="detail.copyrightDetailExtend.authFormRemarks"
            class="remark"
            placeholder="备注信息"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="首发">
          <el-radio-group v-model="detail.isOnly" class="small-form-field" @change="handleCopyrightOnlyChange(detail, $event)">
            <el-radio v-for="(name, id) in isOnlyMap" :key="id" :label="+id">{{ name }}</el-radio>
          </el-radio-group>
          <el-button type="text" @click="detail.remarkShow.isOnlyRemarksShow = true">备注</el-button>
          <el-input
            v-if="detail.remarkShow.isOnlyRemarksShow || detail.copyrightDetailExtend.isOnlyRemarks"
            v-model="detail.copyrightDetailExtend.isOnlyRemarks"
            class="remark"
            placeholder="备注信息"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col v-show="!!detail.isOnly" :span="12">
        <el-form-item label="首发时间模式">
          <el-radio-group v-model="detail.onlyWholeTime" @change="handleOnlyWholeChange(detail, $event)">
            <el-radio :label="1">授权期内</el-radio>
            <el-radio :label="0">按天数</el-radio>
          </el-radio-group>
          <template v-if="detail.onlyWholeTime === 0">
            <el-input-number
              v-model="detail.onlyDuration"
              placeholder="首发天数"
              prefix="天"
              style="margin-left: 12px;width: 120px;"
              :controls="false"
              :min="0"
            ></el-input-number>
            <span style="margin-left: 4px;">天</span>
          </template>
        </el-form-item>
      </el-col>
    </el-row>
    <template #hide>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否可剪辑">
            <el-radio-group v-model="detail.canClip" class="small-form-field">
              <el-radio v-for="(name, id) in canClipMap" :key="id" :label="+id">{{ name }}</el-radio>
            </el-radio-group>
            <el-button type="text" @click="detail.remarkShow.canClipRemarksShow = true">备注</el-button>
            <el-input
              v-if="detail.remarkShow.canClipRemarksShow || detail.copyrightDetailExtend.canClipRemarks"
              v-model="detail.copyrightDetailExtend.canClipRemarks"
              class="remark"
              placeholder="备注信息"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="授权起始时间" prop="date">
            <el-date-picker
              v-model="detail.date"
              style="width:240px"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="授权终端" prop="authTerminal">
            <el-select
              v-model="detail.authTerminal"
              class="small-form-field"
              multiple
              filterable
            >
              <el-option
                v-for="(name, id) in authTerminalMap"
                :key="id"
                :label="id + '. ' + name"
                :value="+id"
              ></el-option>
            </el-select>
            <el-button type="text" @click="detail.remarkShow.authTerminalRemarksShow = true">备注</el-button>
            <el-input
              v-if="detail.remarkShow.authTerminalRemarksShow || detail.copyrightDetailExtend.authTerminalRemarks"
              v-model="detail.copyrightDetailExtend.authTerminalRemarks"
              class="remark"
              placeholder="备注信息"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="硬件厂商合作" prop="cooFactory">
            <el-select
              v-model="detail.cooFactory"
              class="small-form-field"
              multiple
              filterable
            >
              <el-option
                v-for="(name, id) in cooFactoryMap"
                :key="id"
                :label="id + '. ' + name"
                :value="+id"
              ></el-option>
            </el-select>
            <el-button type="text" @click="detail.remarkShow.cooFactoryRemarksShow = true">备注</el-button>
            <el-input
              v-if="detail.remarkShow.cooFactoryRemarksShow || detail.copyrightDetailExtend.cooFactoryRemarks"
              v-model="detail.copyrightDetailExtend.cooFactoryRemarks"
              class="remark"
              placeholder="备注信息"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="排除平台" prop="excludePlatform">
            <el-select
              v-model="detail.excludePlatform"
              class="small-form-field"
              multiple
              filterable
            >
              <el-option
                v-for="(name, id) in excludePlatformMap"
                :key="id"
                :label="id + '. ' + name"
                :value="+id"
              ></el-option>
            </el-select>
            <el-button type="text" @click="detail.remarkShow.excludePlatformRemarksShow = true">备注</el-button>
            <el-input
              v-if="detail.remarkShow.excludePlatformRemarksShow || detail.copyrightDetailExtend.excludePlatformRemarks"
              v-model="detail.copyrightDetailExtend.excludePlatformRemarks"
              class="remark"
              placeholder="备注信息"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="传播网络" prop="network">
            <el-select
              v-model="detail.network"
              class="small-form-field"
              multiple
              filterable
            >
              <el-option
                v-for="(name, id) in networkMap"
                :key="id"
                :label="id + '. ' + name"
                :value="+id"
              ></el-option>
            </el-select>
            <el-button type="text" @click="detail.remarkShow.networkRemarksShow = true">备注</el-button>
            <el-input
              v-if="detail.remarkShow.networkRemarksShow || detail.copyrightDetailExtend.networkRemarks"
              v-model="detail.copyrightDetailExtend.networkRemarks"
              class="remark"
              placeholder="备注信息"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="其他权利" prop="otherRight">
            <el-select
              v-model="detail.otherRight"
              class="small-form-field"
              multiple
              filterable
            >
              <el-option
                v-for="otherRight in otherRightList"
                :disabled="otherRight.disabled"
                :key="otherRight.id"
                :label="otherRight.id + '. ' + otherRight.name"
                :value="+otherRight.id"
              ></el-option>
            </el-select>
            <el-button type="text" @click="detail.remarkShow.otherRightRemarksShow = true">备注</el-button>
            <el-input
              v-if="detail.remarkShow.otherRightRemarksShow || detail.copyrightDetailExtend.otherRightRemarks"
              v-model="detail.copyrightDetailExtend.otherRightRemarks"
              class="remark"
              placeholder="备注信息"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="音源直接内置至接收终端" label-width="180px">
            <el-radio-group v-model="detail.srcInReceiver">
              <el-radio v-for="(name, id) in srcInReceiverMap" :key="id" :label="+id">{{ name }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </template>
  </custom-collapse>
</template>

<script>
import { CpDetail } from '@/models/Contract'
import CustomCollapse from '@/components/CustomCollapse'
import {
  authProductMap,
  isOnlyMap,
  canLegalRightsMap,
  canAuthMap,
  authTerminalMap,
  authFormMap,
  authPlatformMap,
  copyrightAreaMap,
  networkMap,
  excludePlatformMap,
  authFormList,
  otherRightList,
  canClipMap,
  cooFactoryMap,
  srcInReceiverMap,
} from '../../../const'
export default {
  name: 'CopyrightDetailItem',
  components: {
    CustomCollapse
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      authProductMap,
      isOnlyMap,
      canLegalRightsMap,
      canAuthMap,
      authTerminalMap,
      authFormMap,
      authPlatformMap,
      copyrightAreaMap,
      networkMap,
      excludePlatformMap,
      authFormList,
      otherRightList,
      canClipMap,
      cooFactoryMap,
      srcInReceiverMap,

      detail: new CpDetail()
    }
  },

  watch: {
    item: {
      immediate: true,
      deep: true,
      handler() {
        this.detail = this.item
      }
    }
  },

  methods: {
    handleAuthProductChange(value) {
      this.detail.authProductLabel = value.map(item => authProductMap[item]).join(',') || '新增权利'
    },

    handleCopyrightOnlyChange(copyrightDetail, value) {
      if (value === 0) { // 非首发
        // 重置 onlyWholeTime 和 onlyDuration
        copyrightDetail.onlyWholeTime = 0
        copyrightDetail.onlyDuration = 0
      }
    },

    handleOnlyWholeChange(copyrightDetail, value) {
      if (value === 0) {
        copyrightDetail.onlyDuration = 0
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.remark {
  max-width: 120px
}
</style>
